import React from "react";
import { Container, Row, Col, Stack } from "react-bootstrap";
import config from "constants/config";

const LoginFooter = () => {
  const externalLinkRegion = config.defaultCountyCode === "US" ? "us" : "anz";

  return (
    <footer className="mt-auto py-3 bg-white" style={{ borderTop: "1px solid #ff0000" }}>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} md={5} lg={4}>
            <Row>
              <Col className="text-start">
                <Stack direction="horizontal" gap={0} className="flex-wrap small kc-container-wrapper">
                  <a href="mailto:support@qjumpers.com">support@qjumpers.com</a>
                  <span>NZ 07 927 2777 / 0800 758 673</span>
                  <span>US 469-606-0992</span>
                  <a
                    id="terms-conditions"
                    className="text-decoration-none"
                    href={`https://qjumpers.com/${externalLinkRegion}/terms-conditions/`}
                    target="_blank"
                    rel="noreferrer">
                    Terms &amp; Conditions
                  </a>
                  <a
                    id="ai-talent-sourcing-terms-conditions"
                    className="text-decoration-none"
                    href="/AISourcingterms"
                    target="_blank"
                    rel="noreferrer">
                    AI Talent Sourcing Terms &amp; Condition
                  </a>
                  <a
                    id="privacy-statement"
                    className="text-decoration-none"
                    href={`https://qjumpers.com/${externalLinkRegion}/privacy-policy/`}
                    target="_blank"
                    rel="noreferrer">
                    Privacy Statement
                  </a>
                </Stack>
              </Col>
              <Col className="text-end">
                <span className="logo" />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default LoginFooter;
